import React, { useState } from "react";
import { Images, ImageOff, Loader2 } from "lucide-react";
import { setInterventionGallery } from "../../../api";
import { useToast } from "../../../hooks/use-toast";

/** Publier / retirer une intervention terminée (avec photos après) dans la galerie publique /realisations. */
const GalleryToggle = ({ it, onReload }) => {
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();
  const published = !!it.gallery?.published;
  const canPublish = (it.photos_apres || []).length > 0;

  const toggle = async () => {
    setBusy(true);
    try {
      if (published) {
        await setInterventionGallery(it.id, { published: false });
        toast({ title: "Retirée de la galerie" });
      } else {
        const title = window.prompt("Titre public (sans nom de client) :", it.gallery?.title || it.prestation || "");
        if (title === null) return;
        const caption = window.prompt("Légende (facultatif) :", it.gallery?.caption || "") || "";
        await setInterventionGallery(it.id, { published: true, title, caption });
        toast({ title: "Publiée dans la galerie ✓", description: "Visible sur /realisations (ville + photos avant/après, sans nom de client)." });
      }
      onReload();
    } catch (e) {
      toast({ title: "Erreur", description: e?.response?.data?.detail || "Échec", variant: "destructive" });
    } finally { setBusy(false); }
  };

  return (
    <button onClick={toggle} disabled={busy || (!published && !canPublish)} title={!canPublish ? "Une photo « après » est nécessaire" : ""} data-testid={`intv-gallery-${it.id}`}
      className={`text-sm flex items-center gap-1.5 disabled:opacity-50 ${published ? "text-emerald-700 hover:text-red-600" : "text-neutral-600 hover:text-brand"}`}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : published ? <ImageOff size={14} /> : <Images size={14} />}
      {published ? "Retirer de la galerie" : "Publier dans la galerie"}
    </button>
  );
};

export default GalleryToggle;
